import { createTheme } from '@mui/material/styles';
import { colors } from './designTokens';

const theme = createTheme({
  typography: {
    fontFamily: '"DM Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: {
      fontFamily: '"Cormorant Garamond", "Georgia", serif',
      fontWeight: 500,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"Cormorant Garamond", "Georgia", serif',
      fontWeight: 500,
      letterSpacing: '-0.02em',
    },
    h3: { fontWeight: 600, letterSpacing: '-0.01em' },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { lineHeight: 1.7 },
    body2: { lineHeight: 1.65 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  palette: {
    primary: { main: colors.navy, dark: colors.navyDark, light: colors.navyLight },
    secondary: { main: colors.silverDark, light: colors.silverLight, dark: colors.navyMid },
    background: { default: '#ffffff', paper: colors.offWhite },
    text: { primary: colors.text, secondary: colors.slate },
  },
  shape: { borderRadius: 8 },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { overflowX: 'hidden', backgroundColor: '#ffffff' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 600,
          letterSpacing: '0.04em',
          transition: 'all 0.3s ease',
        },
      },
    },
  },
});

export default theme;
